<template>
	<div :class="className" :style="{height:height,width:width}" id="myChart"></div>
</template>

<script>
	import echarts from 'echarts';
	require('echarts/theme/macarons'); // echarts 主题
	import {
		debounce
	} from '../../../util';

	export default {
		props: {
			className: {
				type: String,
				default: 'chart'
			},
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '100%'
			},
			autoResize: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				chart: null
			};
		},
		mounted() {
			this.initChart();
			if (this.autoResize) {
				this.__resizeHanlder = debounce(() => {
					if (this.chart) {
						this.chart.resize()
					}
				}, 100)
				window.addEventListener('resize', this.__resizeHanlder)
			}

			// 监听侧边栏的变化
			const sidebarElm = document.getElementsByClassName('sidebar-container')[0]
			sidebarElm.addEventListener('transitionend', this.__resizeHanlder)
		},
		beforeDestroy() {
			if (!this.chart) {
				return
			}
			if (this.autoResize) {
				window.removeEventListener('resize', this.__resizeHanlder)
			}

			const sidebarElm = document.getElementsByClassName('sidebar-container')[0]
			sidebarElm.removeEventListener('transitionend', this.__resizeHanlder)

			this.chart.dispose()
			this.chart = null
		},
		methods: {
			initChart() {
				var date = new Date();
				var year = date.getFullYear();
				/* 在日期格式中，月份是从0开始的，因此要加0
				 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
				 * */
				var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
				var d = new Date(year, month, 0);
				var day = d.getDate();//当前月天数
				
				this.chart = echarts.init(this.$el, 'macarons');
				let xdata = [];
				for(var i=0;i<day;i++){
					xdata.push((i+1)+"日")
				}
				
				this.chart.setOption({
					title: {
						left: 'left',
						text: '当月每日预约数量趋势图',
						textStyle: { //主标题文本样式{"fontSize": 18,"fontWeight": "bolder","color": "#333"}
							fontFamily: 'Arial, Verdana, sans...',
							fontSize: 14,
							fontStyle: 'normal',
							fontWeight: 'normal',
							color: '#333'
						},
					},
					
					xAxis: {
						data: xdata,
						boundaryGap: false
					},
					grid: {
						left: 10,
						right: 10,
						bottom: 10,
						containLabel: true
					},

					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						}
					},
					yAxis: {},
					series: [{
							name: '学生',
							itemStyle: {
								normal: {
									areaStyle: {}
								}
							},
							smooth: true,
							type: 'line',
							data: [100, 120, 161, 134, 105, 160, 165, 0,100, 120, 161, 134, 105, 160, 165, 0,100, 120, 161, 134, 105, 160, 165, 0,, 0,0,110, 42, 21, 14, 12, 140, 120, 44],
							animationDuration: 2600,
							animationEasing: 'cubicInOut',
						},
						{
							name: '老师',
							smooth: true,
							type: 'line',
							itemStyle: {
								normal: {
									color: 'rgba(2, 197, 233, 0.2)',
									lineStyle: {
										color: 'rgba(2, 197, 233, 0.2)'
									},
									areaStyle: {
										color: 'rgba(99,194,255, 0.6)'
									}
								}
							},
							data: [120, 82, 91, 154, 162, 140, 130, 0,120, 82, 91, 154, 162, 140, 130, 0,120, 82, 91, 154, 162, 140, 130, 0,0,120, 82, 91, 154, 162, 140, 130, 0],
							animationDuration: 2000,
							animationEasing: 'quadraticOut'
						},
					]
				})
				var index = 0; //播放所在下标
				var myChart = echarts.init(document.getElementById("myChart"));
				this.timer = setInterval(()=>{
					myChart.dispatchAction({
					type: 'showTip',
					seriesIndex: 0,
					dataIndex: index
					});
					index++;
					if(index > day) {
					index = 0;
					}
				},2000)
			},
		   
		    created() { //创建完成（可以访问当前this实例）
			
			
		    },
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/editor/lineChart.vue